import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, useState } from 'react';

type Props = {
  onCancel: () => void;
};

export const WhyThisPopUp: React.FC<Props> = ({ onCancel }) => {
  const [open, setOpen] = useState(true);

  return (
    <Transition.Root show={open} as={Fragment} appear>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => {
          setOpen(false);
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={() => {
            setOpen(false);
            onCancel();
          }}
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-surface px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8  sm:p-6">
                <svg
                  className={
                    'text-secondary hover:text-primary w-5 h-5 top-0 right-0 m-1 fixed'
                  }
                  onClick={() => {
                    setOpen(false);
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <div>
                  <h2 className="text-xl leading-9 font-bold text-on-surface">
                    Why do we ask for ...
                  </h2>
                </div>
                <>
                  <div className={'mt-8'}>
                    <ol className="overflow-hidden">
                      <li className="relative pb-10">
                        <span className="relative flex items-start group">
                          <span className="ml-4 min-w-0 flex flex-col">
                            <span className="text-xs font-semibold tracking-wide uppercase text-on-surface">
                              Table Number
                            </span>
                            <span className="text-sm text-on-surface">
                              We need your table number so your server knows
                              where to serve your food.
                            </span>
                          </span>
                        </span>
                      </li>

                      <li className="relative pb-10">
                        <span className="relative flex items-start group">
                          <span className="ml-4 min-w-0 flex flex-col">
                            <span className="text-xs font-semibold tracking-wide uppercase text-on-surface">
                              Email Address
                            </span>
                            <span className="text-sm text-on-surface">
                              We need your email address to send the final
                              receipt. We securely store this information and
                              don't share it with third parties.
                            </span>
                          </span>
                        </span>
                      </li>
                    </ol>

                    <div className="mt-5 sm:mt-6">
                      <button
                        type="button"
                        onClick={() => {
                          setOpen(false);
                        }}
                        id={'dismiss'}
                        className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-on-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:text-sm"
                      >
                        Dismiss
                      </button>
                    </div>
                  </div>
                </>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
